import React from "react";

import ProjectListItem from "./ProjectListItem";

import NoResults from "../../../common/NoResults";
import { SonicProject } from "../../../common/classes/SonicProject";

import styles from "../../../features/management/db-list/DBList.module.scss";

type Props = {
  projects: Array<SonicProject>;
  isSelect: boolean;
  owners: { email: string; roles: string[]; full_name?: string }[];
};

const ProjectList: React.FC<Props> = ({ projects, isSelect, owners }) => {
  if (projects.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["project"]}`}
      >
        <div>プロジェクト名</div>
        <div>カテゴリ</div>
        <div>作成者名</div>
        <div>掲載期間</div>
        <div>応募者数</div>
        <div>ステータス</div>
        <div>アクション</div>
      </div>
      {projects.map((project, i) => (
        <ProjectListItem
          key={i}
          i={i}
          id={project.id}
          name={project.name}
          category={project.type}
          owner_name={
            !isSelect && owners[i].full_name
              ? (owners[i].full_name as string)
              : project.owner_name
          }
          applicants={project.applicants}
          start_date={project.start_date}
          end_date={project.end_date}
          status={project.status}
          isSelect={isSelect}
        />
      ))}
    </div>
  );
};

export default ProjectList;
